<template lang='pug'>
  i.svg-icon.svg-icon-money
    svg(
      :fill='color'
      :width='`${size}px`'
      :height='`${size}px`'
      viewBox='0 0 100 100'
    )
      path(d='M80.748,63.485c0,12.133-8.729,18.925-26.188,20.371v7.877h-8.771v-7.605c-8.271-0.36-14.662-2.534-19.172-6.519 c-4.594-3.924-6.934-9.446-7.017-16.567h16.917c0,6.277,3.09,9.839,9.272,10.684V53.8c-7.853-2.175-13.408-4.316-16.666-6.429 c-4.929-3.199-7.393-7.575-7.393-13.128c0-5.371,2.256-9.869,6.768-13.489c4.511-3.682,10.275-5.855,17.292-6.519V7.354h8.771v6.79 c15.454,0.966,23.766,7.907,24.937,20.823H62.453c-0.334-4.949-2.966-7.756-7.894-8.419v16.296 c8.271,2.292,14.117,4.466,17.542,6.519C77.866,52.804,80.748,57.51,80.748,63.485z M45.789,40.31V26.819 c-4.845,1.026-7.268,3.26-7.268,6.699C38.521,36.234,40.943,38.498,45.789,40.31z M63.707,63.76c0-3.202-3.05-5.705-9.147-7.516 v15.573C60.657,70.85,63.707,68.163,63.707,63.76z')
      



</template>

<script>
export default {

  props: {
    size: {
      type: Number,
      default: 20,
    },
    color: {
      type: String,
      default: '#333',
    },
  },

}
</script>